export function insertIf<T>(
  condition: boolean,
  ...elements: (T | (() => T))[]
): T[] {
  return condition
    ? elements.map((e) => (typeof e === 'function' ? (e as () => T)() : e))
    : [];
}
